module.exports = __webpack_public_path__ + "img/back-arrow-left-v2.3ac67ee1.svg";